'use strict';
import React, { Component } from 'react';
import { Redirect } from 'react-router';
import DatosGenerales from './DatosGenerales/DatosGenerales.jsx';
import Emision from './Emision/Emision.jsx';
import Limites from './Limites/Limites.jsx';
import Facturacion from './Facturacion/Facturacion.jsx';
import FormaPago from './FormaPago/FormaPago.jsx';

//DatosGenerales
import TipoCuenta from './DatosGenerales/Visa/TipoCuenta.jsx';
import SucursalesLink from './DatosGenerales/SucursalesLink.jsx';
import SucursalesSeleccionadas from './DatosGenerales/SucursalesSeleccionadas.jsx';
import GruposAfinidadLink from './DatosGenerales/Cabal/GruposAfinidadLink.jsx';
import GruposAfinidadSeleccionadas from './DatosGenerales/Cabal/GruposAfinidadSeleccionadas.jsx';
import GruposAfinidadVisa from './DatosGenerales/Visa/GruposAfinidadVisa.jsx';
import SegmentoCartera from './DatosGenerales/Cabal/SegmentoCartera.jsx';
import MarcaCompartida from './DatosGenerales/Cabal/MarcaCompartida.jsx';
import DenominacionCuartaLinea from './DatosGenerales/DenominacionCuartaLinea.jsx';
import Distribucion from './DatosGenerales/Visa/Distribucion.jsx';
import ComercializadoresCanalesHabilitados from './DatosGenerales/Visa/ComercializadoresCanalesHabilitados.jsx';
import Correspondencia from './DatosGenerales/Visa/Correspondencia.jsx';

//Emision
import CostoEmision from './Emision/Visa/CostoEmision.jsx';
import PreEmisionCabal from './Emision/Cabal/PreEmisionCabal.jsx';
import AltaPosDatadaCabal from './Emision/Cabal/AltaPosDatadaCabal.jsx';
import RetencionTarjetaCabal from './Emision/Cabal/RetencionTarjetaCabal.jsx';

//Limites
import ModalidadDistribucionLimiteTarjeta from './Limites/Visa/ModalidadDistribucionLimiteTarjeta.jsx';
import LimiteCompraLink from './Limites/Visa/LimiteCompraLink.jsx';
import LimiteCompraSeleccionado from './Limites/Visa/LimiteCompraSeleccionado.jsx';
import LimiteInput from './Limites/Visa/LimiteInput.jsx';
import FuncionamientoLimites from './Limites/Visa/FuncionamientoLimites.jsx';
import FactorLimiteCompraCuotas from './Limites/Visa/FactorLimiteCompraCuotas.jsx';
import LineasPrestamo from './Limites/Visa/LineasPrestamo.jsx';
import LimiteCompraCabal from './Limites/Cabal/LimiteCompraCabal.jsx';
import CoeficienteLimiteCompraCabal from './Limites/Cabal/CoeficienteLimiteCompraCabal.jsx';


//Facturacion
import LimiteFinanciacionNuevo from './Facturacion/Visa/LimiteFinanciacionNuevo.jsx';
import Carteras from './Facturacion/Carteras.jsx';
import ModelosLiquidacion from './Facturacion/Visa/ModelosLiquidacion.jsx';
import CategoriasAtm from './Facturacion/Visa/CategoriasAtm.jsx';
import HabilitacionTarjetaCajeroAutomatico from './Facturacion/Visa/HabilitacionTarjetaCajeroAutomatico.jsx';
import UsoCajeroAutomatico from './Facturacion/Visa/UsoCajeroAutomatico.jsx';
import LimiteFinanciacionCabal from './Facturacion/Cabal/LimiteFinanciacionCabal.jsx';
import TopePagoMinimoCabal from './Facturacion/Cabal/TopePagoMinimoCabal.jsx';

//import AdvancedRules from './AdvancedRules.jsx';
import Footer from './Footer.jsx';
import { GenericModal, GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import { createForm } from 'rc-form';


class Producto extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.resetState();
        const id = this.props.match.params.id;
        this.props.getScreenData(id, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetState();
    }
    render() {
        //this.props.data.GET_PARAMETRO_GENERAL
        const { showMoreBranches, showLessBranches, saveSelectedBranches, cancelSelectedBranches, removeSelectedBranch,
            data, form, redirect, finishProduct, addAdvancedRule, getDataByAdministratorId, cancelProduct, noSucursalSelected,
            noSeleccionAmbasReglasAvanzadas, errorSave, routeToPrevious, validateAddProduct, saveSelectedPurchaseLimits,
            removeSelectedPurchaseLimit, showMorePurchaseLimits, showLessPurchaseLimits, cancelSelectedPurchaseLimits,
            selectCheckBox, selectRadio, selectCombo, changeInput, getGruposafinidad } = this.props;

        const { functions, selectedAdministrator, TipoProductoEmpInd, GET_PARAMETRO_GENERAL } = data;

        const cuentaTipo = data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.find(x => x.Checked);
        let datosGenerales = null;
        let emision = null;
        let limites = null;
        let facturacion = null;
        
       
        switch (selectedAdministrator) {
            case "C":

                datosGenerales = <div>
                    <SucursalesLink data={data} saveSelectedBranches={saveSelectedBranches} cancelSelectedBranches={cancelSelectedBranches} />
                    <SucursalesSeleccionadas data={data} removeSelectedBranch={removeSelectedBranch} showMoreBranches={showMoreBranches} showLessBranches={showLessBranches} />
                    <GruposAfinidadLink asociaGA={data.AsociaGrupoAfinidad} data={data} saveSelectedBranches={saveSelectedBranches} cancelSelectedBranches={cancelSelectedBranches} selectCheckBox={selectCheckBox} selectCombo={selectCombo} removeSelectedBranch={removeSelectedBranch}  showMoreBranches={showMoreBranches} showLessBranches={showLessBranches} />
                    {(data.GET_PARAMETRO_GENERAL && data.GET_PARAMETRO_GENERAL.SINOSEGMENTOSCARTERA) && <SegmentoCartera data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />}
                    {(data.GET_PARAMETRO_GENERAL && data.GET_PARAMETRO_GENERAL.SINOMARCACOMPARTIDA) && <MarcaCompartida data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />}
                    <DenominacionCuartaLinea data={data} form={form} selectCheckBox={selectCheckBox} selectRadio={selectRadio} changeInput={changeInput} />
                    <Correspondencia data={data} selectCheckBox={selectCheckBox} selectRadio={selectRadio} selectCombo={selectCombo} />
                </div>;

                emision = <div>
                    <PreEmisionCabal form={form} data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} selectRadio={selectRadio} selectCombo={selectCombo} />
                    <AltaPosDatadaCabal form={form} data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} selectCombo={selectCombo} />
                    <RetencionTarjetaCabal form={form} data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} selectCombo={selectCombo} />
                </div>;

                limites = <div>
                    <LimiteCompraCabal form={form} data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} />
                    <CoeficienteLimiteCompraCabal form={form} data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} />
                </div>;

                facturacion = <div>
                    <LimiteFinanciacionCabal form={form} data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} />
                    {(data.GET_PARAMETRO_GENERAL && data.GET_PARAMETRO_GENERAL.SINOTOPEPAGOMINIMO) &&<TopePagoMinimoCabal form={form} data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} />}
                    <Carteras data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} titulo="Ciclo de Facturación" textValidacion="Debe seleccionar al menos un ciclo de facturacion." />
                </div>;

                break;
            case "V":

                datosGenerales = <div>
                    <TipoCuenta getGruposafinidad={getGruposafinidad} data={data} selectCheckBox={selectCheckBox} selectRadio={selectRadio} AdministradoraId={1} />
                    <SucursalesLink data={data} saveSelectedBranches={saveSelectedBranches} cancelSelectedBranches={cancelSelectedBranches} />
                    <SucursalesSeleccionadas data={data} removeSelectedBranch={removeSelectedBranch} showMoreBranches={showMoreBranches} showLessBranches={showLessBranches} />
                    <GruposAfinidadVisa  data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />
                    <DenominacionCuartaLinea data={data} form={form} selectCheckBox={selectCheckBox} selectRadio={selectRadio} changeInput={changeInput} />
                    <Distribucion data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />
                    <ComercializadoresCanalesHabilitados data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />
                    <Correspondencia data={data} selectCheckBox={selectCheckBox} selectRadio={selectRadio} selectCombo={selectCombo} />
                </div>;

                emision = <div>
                    {TipoProductoEmpInd === "I" && <CostoEmision data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo}
                        selectRadio={selectRadio} changeInput={changeInput} form={form} />}
                </div>;

                limites = <div>
                    <FuncionamientoLimites data={data} selectRadio={selectRadio} />
                    <ModalidadDistribucionLimiteTarjeta data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />
                    {
                        (cuentaTipo && cuentaTipo.TipoLimite == 'M') &&
                        <div>
                            <LimiteInput cuentaTipo={cuentaTipo} form={form} changeInput={changeInput} data={data} />
                        </div>
                    }
                    {
                        (cuentaTipo && cuentaTipo.TipoLimite == 'L') &&
                        <div>
                            <LimiteCompraLink parametroGeneral={GET_PARAMETRO_GENERAL} data={data} saveSelectedPurchaseLimits={saveSelectedPurchaseLimits} cancelSelectedPurchaseLimits={cancelSelectedPurchaseLimits} />
                            <LimiteCompraSeleccionado data={data} removeSelectedPurchaseLimit={removeSelectedPurchaseLimit} selectCombo={selectCombo} selectCheckBox={selectCheckBox}
                                showMorePurchaseLimits={showMorePurchaseLimits} showLessPurchaseLimits={showLessPurchaseLimits} />
                        </div>
                    }
                    {<FactorLimiteCompraCuotas data={data} form={form} changeInput={changeInput} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />}                    <LineasPrestamo data={data} selectCombo={selectCombo} selectCheckBox={selectCheckBox} />
                </div>;

                facturacion = <div>
                    {(GET_PARAMETRO_GENERAL && GET_PARAMETRO_GENERAL.SINOLIMITEFINANCIACIONCUENTA) &&<LimiteFinanciacionNuevo data={data} selectCheckBox={selectCheckBox} changeInput={changeInput} form={form} />}
                    {data.TipoProductoEmpInd == "I" && <Carteras data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} titulo="Carteras" textValidacion="Debe seleccionar al menos una cartera." />}
                    <ModelosLiquidacion data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />
                    <CategoriasAtm data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />
                    <HabilitacionTarjetaCajeroAutomatico data={data} selectCheckBox={selectCheckBox} selectCombo={selectCombo} />
                    <UsoCajeroAutomatico data={data} selectRadio={selectRadio} />
                </div>;

                break;
        }

        if (functions) {
            if (redirect.shouldRedirect)
                return <Redirect to={redirect.to} push />;

            if (data.functions.Alta == true) {
                return <form id="bloqueoCrearProducto" name="bloqueoCrearProducto" className="" method="POST">
                    <div className="container-fluid tarjetas">
                        <DatosGenerales
                            //FUNCIONES PARA SELECTOR DE SUCURSALES
                            showMoreBranches={showMoreBranches}
                            showLessBranches={showLessBranches}
                            saveSelectedBranches={saveSelectedBranches}
                            cancelSelectedBranches={cancelSelectedBranches}
                            removeSelectedBranch={removeSelectedBranch}
                            addAdvancedRule={addAdvancedRule}

                            data={data}
                            getDataByAdministratorId={getDataByAdministratorId}
                            cancelProduct={cancelProduct}
                            selectCheckBox={selectCheckBox}
                            selectCombo={selectCombo}
                            selectRadio={selectRadio}
                            changeInput={changeInput}
                            noSucursalSelected={noSucursalSelected}
                            noSeleccionAmbasReglasAvanzadas={noSeleccionAmbasReglasAvanzadas}
                            errorSave={errorSave}
                            routeToPrevious={routeToPrevious}
                            validateAddProduct={validateAddProduct}
                            form={form}
                        >

                            {datosGenerales}

                        </DatosGenerales>

                        <Emision
                            form={form}
                            data={data}
                            selectCheckBox={selectCheckBox}
                            selectCombo={selectCombo}
                            selectRadio={selectRadio}
                            changeInput={changeInput}
                        >

                            {emision}

                        </Emision>

                        <Limites
                            form={form}
                            data={data}
                            selectCheckBox={selectCheckBox}
                            selectCombo={selectCombo}
                            changeInput={changeInput}
                            selectRadio={selectRadio}
                            saveSelectedPurchaseLimits={saveSelectedPurchaseLimits}
                            removeSelectedPurchaseLimit={removeSelectedPurchaseLimit}
                            showMorePurchaseLimits={showMorePurchaseLimits}
                            showLessPurchaseLimits={showLessPurchaseLimits}
                            cancelSelectedPurchaseLimits={cancelSelectedPurchaseLimits}
                        >

                            {limites}

                        </Limites>

                        <Facturacion
                            form={form}
                            data={data}
                            selectCheckBox={selectCheckBox}
                            selectCombo={selectCombo}
                            selectRadio={selectRadio}
                            changeInput={changeInput}
                        >
                            {facturacion}

                        </Facturacion>

                        <FormaPago
                            form={form}
                            data={data}
                            selectCheckBox={selectCheckBox}
                            selectCombo={selectCombo}
                            changeInput={changeInput}
                        />

                        <br />
                        <Footer
                            data={data}
                            cancelProduct={cancelProduct}
                            noSucursalSelected={noSucursalSelected}
                            noSeleccionAmbasReglasAvanzadas={noSeleccionAmbasReglasAvanzadas}
                            errorSave={errorSave}
                            validateAddProduct={validateAddProduct}
                            form={form}
                        />

                        <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"error"}
                            header={"La transacción no puede ser procesada"}
                            body={"Por favor comuniquese con Soporte técnico para recibir asistencia y solucionarlo lo antes posible. Su número de transacción es " + this.props.data.sagaId}
                            onClick={finishProduct} />
                        <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"completada"}
                            body={"La transacción ha sido creada exitosamente"}
                            onClick={finishProduct} />
                        <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"completadaConDependencias"}
                            header={"La transacción esta pendiente a ser procesada"}
                            body={"Disculpe, hay datos en la transacción que dependen de procesos que todavían no fueron finalizados, por lo que aun no se encuentra confirmada.\nUsted no debe hacer nada: Una vez que los procesos de los que dependen esta transacción hayan finalizado correctamente será avisado y la transacción avanzará automáticamente por su circuito normal."}
                            onClick={finishProduct} />
                    </div>
                </form>
            } else {
                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                return <GenericErrorScreen data={values} />;
            }
        } else {
            return null;
        }
    }
}

export default createForm()(Producto);

/*

 */